import { useMutation, useQueryClient } from '@tanstack/react-query'

import { useAlerts } from '../../../theme/hooks/useAlerts'
import { queryKey } from '../hooks/useSearchActiviteitenForEntity'
import { patchActiviteitForEntity } from '../services/patchActiviteitForEntity'

export { usePatchActiviteitForEntity }

const usePatchActiviteitForEntity = () => {
  const queryClient = useQueryClient()
  const { successAlert } = useAlerts()

  return useMutation({
    mutationFn: patchActiviteitForEntity,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKey] })
      successAlert('Activiteit successvol bijgewerkt')
    },
  })
}
